// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"716":"017758fb","752":"3c01446c"}[chunkId] + ".chunk.css";
};